"use client"
import React from 'react'
import HoverManager from "@/components/HoverManager"
import Cursor from "@/components/Cursor"
import { useScreenType } from '@/contexts/ScreenTypeContext'

export default function ClientHoverFeatures() {

  const { screenType, isDesktop, isBigscreen } = useScreenType()

  if (screenType === "loading") {
    // Decide what to render while screen type is being determined.
    // For UI elements like HoverManager and Cursor, often null is fine.
    return null
  }

  if (isDesktop || isBigscreen) {
    return (
      <>
        <HoverManager />
        <Cursor />
      </>
    )
  }

  return null
}
